import React, { useEffect, useRef, useState } from "react";

import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  TextInput,
  FlatList,
} from "react-native";
import { AntDesign } from "@expo/vector-icons";
import Modal from "modal-enhanced-react-native-web";
import ManageThemes from "./manageThemes";
import { apiservice } from "../service/api";
import { useRecoilState, useRecoilValue } from "recoil";
import { tokenState, univer, userState } from "../reducer";
const { width, height } = Dimensions.get("window");

const manageApplications = ({ navigation, setPage }) => {
  const [data1, setdata1] = useState([]);
  const [fill, setFill] = useState("");
  const token = useRecoilValue(tokenState);
  const [user, setUser] = useRecoilState(userState);
  const [university, setUniversity] = useRecoilState(univer);
  const [modalAddUniversity, setmodalAddUniversity] = useState(false);
  const [page, setpage] = useState(0);
  const [modal, setmodal] = useState(false);
  const [body, setBody] = useState({
    name: "",
    theme: {
      header: "#FFF",
      button: "#FFF",
      text: "#FFF",
      icon: "#FFF",
      calender: "#FFF",
      title: "#FFF",
    },
    logo: "https://api.cquiz.app/api/image/get/user",
  });

  const [items, setItem] = useState({
    name: "",
    theme: {
      header: "#FFF",
      button: "#FFF",
      text: "#FFF",
      icon: "#FFF",
      calender: "#FFF",
      title: "#FFF",
    },
    logo: "https://api.cquiz.app/api/image/get/user",
  });

  async function createUniversity() {
    const res = await apiservice({
      path: "/university/create",
      method: "post",
      body,
    });
    if (res.status == 200) {
      setBody({
        name: "",
        theme: {
          header: "#FFF",
          button: "#FFF",
          text: "#FFF",
          icon: "#FFF",
          calender: "#FFF",
          title: "#FFF",
        },
        logo: "https://api.cquiz.app/api/image/get/user",
      });
      getallUniversity();
      setmodalAddUniversity(false);
      setmodal(false);
    }
  }

  async function deleteUniversity(params) {
    const res = await apiservice({
      path: "/university/delete/" + params,
      method: "delete",
    });
    if (res.status == 200) {
      getallUniversity();
      setmodalAddUniversity(false);
      setmodal(false);
    }
  }

  async function updateUniversity() {
    const res = await apiservice({
      path: "/university/update",
      method: "put",
      body: items,
    });
    console.log(res.data);
    if (res.status == 200) {
      getallUniversity();
      setmodalAddUniversity(false);
      setmodal(false);
      if (token.role == "SUPERADMIN") {
        setpage(0);
      }
    }
  }

  async function getallUniversity() {
    const res = await apiservice({
      path: "/university/all",
      method: "get",
    });
    if (res.status == 200) {
      setdata1(res.data.result);

      if (token.role == "ADMIN") {
        setItem(
          res.data.result.filter((item) => {
            return item.id == user.university_id;
          })[0]
        );
        setpage(1);
      }
    }
  }

  useEffect(() => {
    getallUniversity();
  }, []);

  return (
    <View style={styles.container}>
      <Modal
        animationType="none"
        transparent={true}
        visible={modal}
        onRequestClose={() => {
          setmodal(!modal);
        }}
      >
        <View
          style={{
            width: width,
            height: height,
            backgroundColor: "#000000bb",
            justifyContent: "center",
          }}
        >
          <View
            style={{
              width: width * 0.5,
              height: height * 0.3,
              backgroundColor: "#fff",
              paddingHorizontal: 20,
              justifyContent: "center",
              alignSelf: "center",
            }}
          >
            <Text
              style={{
                fontSize: 18,
                fontFamily: "Prompt-Bold",
                color: "#202020",
                alignSelf: "center",
              }}
            >
              ต้องการลบ มหาวิทยาลัย นี้ใช่หรือไหม
            </Text>
            <View
              style={{
                width: width * 0.3,
                flexDirection: "row",
                justifyContent: "space-between",
                alignSelf: "center",
                marginTop: 20,
              }}
            >
              <TouchableOpacity
                onPress={() => setmodal(false)}
                style={{
                  width: 120,
                  height: 35,
                  borderWidth: 1,
                  overflow: "hidden",
                  borderColor: "#000",
                  borderRadius: 5,
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    fontFamily: "Prompt-Regular",
                    fontSize: 16,
                    alignSelf: "center",
                  }}
                >
                  ยกเลิก
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => {
                  deleteUniversity(items.id);
                }}
                style={{
                  width: 120,
                  height: 35,
                  borderWidth: 1,
                  overflow: "hidden",
                  borderColor: "#000",
                  borderRadius: 5,
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    fontFamily: "Prompt-Regular",
                    fontSize: 16,
                    alignSelf: "center",
                  }}
                >
                  ตกลง
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
      <Modal isVisible={modalAddUniversity}>
        <View
          style={{
            width: width * 0.41,
            height: height * 0.27,
            backgroundColor: "#ffff",
            alignSelf: "center",
            alignItems: "center",
            borderRadius: 10,
            justifyContent: "center",
          }}
        >
          <Text
            style={{
              fontSize: 24,
              fontFamily: "Prompt-Regular",
              color: "#272727",
              margin: "auto",
            }}
          >
            เพิ่ม
          </Text>
          <View
            style={{
              width: width * 0.354,
              height: 30,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              margin: "auto",
            }}
          >
            <Text
              style={{
                fontSize: 18,
                fontFamily: "Prompt-Regular",
                color: "#272727",
              }}
            >
              ชื่อ
            </Text>
            <TextInput
              value={body.name}
              onChangeText={(text) => {
                setBody((val) => ({ ...val, name: text }));
              }}
              style={styles.TextInput}
            />
          </View>

          <View
            style={{
              width: width * 0.2,
              height: 30,
              flexDirection: "row",
              justifyContent: "space-around",
              alignItems: "center",
              margin: "auto",
            }}
          >
            <TouchableOpacity
              onPress={createUniversity}
              style={{
                width: 100,
                height: 40,
                borderRadius: 5,
                backgroundColor: "#69D443",
                marginRight: 20,
              }}
            >
              <Text style={styles.TextButton}>ยืนยัน</Text>
            </TouchableOpacity>

            <TouchableOpacity
              onPress={() => {
                setmodalAddUniversity(!modalAddUniversity);
              }}
              style={{
                width: 100,
                height: 40,
                borderRadius: 5,
                backgroundColor: "#D44343",
              }}
            >
              <Text style={styles.TextButton}>ยกเลิก</Text>
            </TouchableOpacity>
          </View>
        </View>
      </Modal>

      {page == 0 && (
        <View
          style={{
            width: width * 0.82,
            height: height * 0.9,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Text
            style={{
              width: width * 0.591,
              fontSize: 18,
              fontFamily: "Prompt-Bold",
              color: "#202020",
            }}
          >
            มหาวิทยาลัย/หน่วยงาน/องค์กร
          </Text>

          <View
            style={{
              width: width * 0.591,
              height: height * 0.06,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <View
              style={{
                width: width * 0.235,
                height: height * 0.037,
                flexDirection: "row",
              }}
            >
              <TextInput
                value={fill}
                onChangeText={setFill}
                onEndEditing={async () => {
                  const res = await apiservice({
                    path: "/university/all",
                    method: "get",
                  });

                  setdata1(
                    res.data.result.filter((items) => items.name.includes(fill))
                  );
                }}
                style={{
                  width: width * 0.8,
                  height: height * 0.037,
                  borderWidth: 1,
                  overflow: "hidden",
                  borderColor: "#00237740",
                  paddingLeft: 5,
                  fontFamily: "Prompt-Regular",
                  fontSize: 12,
                }}
              />
              <TouchableOpacity
                onPress={async () => {
                  const res = await apiservice({
                    path: "/university/all",
                    method: "get",
                  });

                  setdata1(
                    res.data.result.filter((items) => items.name.includes(fill))
                  );
                }}
                style={{
                  width: width * 0.022,
                  height: height * 0.037,
                  backgroundColor: "#002377",
                }}
              >
                <AntDesign
                  name="search1"
                  style={{ margin: "auto" }}
                  size={15}
                  color="#ffff"
                />
              </TouchableOpacity>
            </View>
            {token.role == "SUPERADMIN" && (
              <TouchableOpacity
                onPress={() => {
                  setmodalAddUniversity(true);
                }}
                style={{
                  width: width * 0.065,
                  height: height * 0.037,
                  backgroundColor: "#43A2D4",
                  borderRadius: 5,
                }}
              >
                <Text style={styles.TextButton}>+ เพิ่มข้อมูล</Text>
              </TouchableOpacity>
            )}
          </View>

          <View
            style={{
              width: width * 0.591,
              height: height * 0.54,
              borderWidth: 1,
              overflow: "hidden",
              borderColor: "#C2C2C2",
              borderTopLeftRadius: 5,
              borderTopRightRadius: 5,
            }}
          >
            <View
              style={{
                width: width * 0.591,
                height: height * 0.054,
                backgroundColor: "#002377",

                flexDirection: "row",
                borderTopLeftRadius: 5,
                borderTopRightRadius: 5,
                justifyContent: "space-between",
              }}
            >
              <View
                style={{
                  width: width * 0.25,
                  height: height * 0.054,
                  justifyContent: "center",
                  paddingLeft: 50,
                }}
              >
                <Text style={styles.Textheader}> มหาวิทยาลัย/หน่วยงาน/องค์กร</Text>
              </View>

              <View
                style={{
                  width: width * 0.123,
                  height: height * 0.054,
                  justifyContent: "center",
                }}
              >
                <Text style={[styles.Textheader, { margin: "auto" }]}>
                  จัดการ
                </Text>
              </View>
            </View>

            {token.role == "SUPERADMIN" && (
              <FlatList
                data={data1}
                renderItem={({ item, index }) => {
                  return (
                    <TouchableOpacity
                      onPress={() => {
                        setUniversity(item);
                        setUser(val => ({ ...val, university_id: item.id }))

                        setTimeout(() => {
                          setPage(5)
                        }, 300);
                      }}
                      style={{
                        width: width * 0.591,
                        height: height * 0.046,
                        flexDirection: "row",
                        justifyContent: "space-between",
                        backgroundColor: index % 2 == 0 ? "#ffff" : "#E8E8E8",
                      }}
                    >
                      <View
                        style={{
                          width: width * 0.25,
                          height: height * 0.046,
                          justifyContent: "center",
                          paddingLeft: 50,
                        }}
                      >
                        <Text style={styles.Textdata}>{item.name}</Text>
                      </View>
                    </TouchableOpacity>
                  );
                }}
              />
            )}

            {token.role == "ADMIN" && (
              <FlatList
                data={data1.filter((item) => {
                  return item.id == user.university_id;
                })}
                renderItem={({ item, index }) => {
                  console.log("GFG", item);
                  return (
                    <View
                      style={{
                        width: width * 0.591,
                        height: height * 0.046,
                        flexDirection: "row",
                        justifyContent: "space-between",
                        backgroundColor: index % 2 == 0 ? "#ffff" : "#E8E8E8",
                      }}
                    >
                      <View
                        style={{
                          width: width * 0.25,
                          height: height * 0.046,
                          justifyContent: "center",
                          paddingLeft: 50,
                        }}
                      >
                        <Text style={styles.Textdata}>{item.name}</Text>
                      </View>

                      <View
                        style={{
                          width: width * 0.125,
                          height: height * 0.046,
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "space-evenly",
                        }}
                      >
                        <TouchableOpacity
                          onPress={() => {
                            setItem(item);
                            setpage(1);
                          }}
                          style={{
                            width: 115,
                            height: 30,
                            borderRadius: 5,
                            backgroundColor: "#69D443",
                          }}
                        >
                          <Text style={styles.TextButton}>จัดการธีม</Text>
                        </TouchableOpacity>

                        {token.role == "SUPERADMIN" && (
                          <TouchableOpacity
                            onPress={() => {
                              setItem(item);
                              setmodal(true);
                            }}
                            style={{
                              width: 70,
                              height: 30,
                              borderRadius: 5,
                              backgroundColor: "#D44343",
                            }}
                          >
                            <Text style={styles.TextButton}>ลบ</Text>
                          </TouchableOpacity>
                        )}
                      </View>
                    </View>
                  );
                }}
              />
            )}
          </View>
        </View>
      )}
      {page == 1 && (
        <ManageThemes
          onPress={updateUniversity}
          items={items}
          setItem={setItem}
          navigation={navigation}
        />
      )}
    </View>
  );
};
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#ffff",
  },
  Textheader: { fontSize: 18, color: "#ffff", fontFamily: "Prompt-Regular" },
  Textdata: { fontSize: 16, fontFamily: "Prompt-Regular" },
  TextButton: {
    fontSize: 16,
    color: "#ffff",
    margin: "auto",
    fontFamily: "Prompt-Regular",
  },
  TextInput: {
    width: width * 0.286,
    height: 30,
    borderWidth: 1,
    overflow: "hidden",
    borderColor: "#70707040",
    fontSize: 16,
    fontFamily: "Prompt-Regular",
    paddingLeft: 10,
  },
});
export default manageApplications;
